// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VT3G","productName":"Table_productName__3k8XL"};